import { Body, Button, Heading } from '@e2n/ui/v2';
import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';
import type { RotationsplanVorlageDetails } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanVorlageById/useRotationsplanVorlageById';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function VorlageHeader({
  vorlage,
}: {
  vorlage: RotationsplanVorlageDetails;
}) {
  const { t } = useTranslation();
  const { beruf } = vorlage;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2 items-center min-w-0">
        <span
          aria-hidden
          className="size-2.5 shrink-0 rounded-full"
          style={{
            backgroundColor: getColorsForMarkierung(
              beruf.markierung as unknown as Markierung,
            ).base,
          }}
        />
        <Body className="truncate" weight="semibold">
          {beruf.name}
        </Body>
        {beruf.abkuerzung && (
          <Body asChild className="text-labels-secondary">
            <span>{`· ${beruf.abkuerzung}`}</span>
          </Body>
        )}
      </div>
      <div className="flex gap-2 items-center min-w-0">
        <Heading className="md:text-2xl">{vorlage.titel}</Heading>
        <Button asChild iconOnly size="small" variant="secondary-red">
          <Link
            aria-label={t('actions.bearbeiten')}
            to={`/mitarbeiter/rotationsplaene/vorlagen/${vorlage.id}/update`}>
            <FontAwesomeIcon icon={faPen} />
          </Link>
        </Button>
      </div>
    </div>
  );
}
